import axios from 'axios';
import MD5 from "crypto-js/md5";

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-api-gateway-url.amazonaws.com/prod';
const API_LOGIN_KEY = process.env.REACT_APP_API_KEY

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': API_LOGIN_KEY
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authService = {
  async login(email, typedpassword) {
    const password = MD5(typedpassword).toString();
    const response = await api.post('/authlogin', { cmd: "login", email, password });
    return response.data;
  },

  async register(userData) {
    userData.password = MD5(userData.password).toString();
    const response = await api.post('/authlogin', { cmd: "register", userData: userData });
    if (response && response.data) {
      if (response.data.statusCode > 201) {
        throw new Error(response.data.body);
      }
    }
    return response.data;
  },

  async validateToken(token) {
    const response = await api.get('/auth/validate', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  async changePassword({ currentPassword, newPassword }) {
    const hashedCurrentPassword = MD5(currentPassword).toString();
    const hashedNewPassword = MD5(newPassword).toString();
    
    // Get user email from localStorage
    const user = JSON.parse(localStorage.getItem('user'));
    const userEmail = user?.email;
    
    const response = await api.post('/authlogin', {
      cmd: "changePassword",
      email: userEmail,
      currentPassword: hashedCurrentPassword,
      newPassword: hashedNewPassword
    });
    return response.data;
  },

  async activate(token) {
    const response = await api.post('/authlogin', {
      cmd: "activate",
      token: token
    });
    return response.data;
  },

  async updateUser(userId, updateData) {
    const response = await api.post('/authlogin', {
      cmd: "updateUser",
      userId: userId,
      updateData: updateData
    });
    return response.data;
  }
};

export default api;